
//For Home Page(State Data) API
 
export const FETCH_REQUEST='FETCH_REQUEST';
export const FETCH_SUCCESS='FETCH_SUCCESS';
export const ERROR='ERROR';

//For Notifications API

export const FETCH_NOTIFICATION_REQ='FETCH_NOTIFICATION_REQ';
export const FETCH_NOTIFICATION_SUCCESS='FETCH_NOTIFICATION_SUCCESS';
export const FETCH_NOTIFICATION_ERROR='FETCH_NOTIFICATION_ERROR';

export const IS_ASC='IS_ASC';
export const IS_DES='IS_DES';
export const SORT_HOME_DATA='SORT_HOME_DATA';
export const IS_TES='IS_TES';

export const DISTRICT_DATA='DISTRICT_DATA';
export const SET_DISTRICT_DATA='SET_DISTRICT_DATA';